module.exports = __webpack_public_path__ + "img/de.5c9661f6.svg";